import {Query, RunSetQuery} from '../../../util/queryTypes';

export function getRunSets(query: Query): RunSetQuery[] {
  if (query.runSets == null) {
    return [];
  }

  return query.runSets.map(rs => ({
    id: rs.id,
    grouping: rs.grouping,
    entityName: rs.entityName,
    projectName: rs.projectName,
    filters: rs.filters,
    sort: rs.sort,
    runNameTruncationType: rs.runNameTruncationType,
  }));
}
